import { toNumber2e2hj9zugjwi2 as toNumber } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toJSDate(_this__u8e3s4) {
  return new Date(toNumber(_this__u8e3s4.t26()));
}
//region block: exports
export {
  toJSDate as toJSDate14542kwfw0zmu,
};
//endregion

//# sourceMappingURL=Converters.mjs.map
